/* eslint-disable @typescript-eslint/naming-convention */
export class ExternalTransferDescriptionDto {
	public TransferId: string;
	public TransferDescription: string;
}
